import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  DatePicker,
  Popover,
  Select,
  Space,
  Tooltip,
} from "antd";
import type { Dayjs } from "dayjs";
import { EqualizerIcon } from "@/shared/assets/svg/icons";
import { InputSearch } from "@shared/ui";
import type { JournalsAmendmentsStatus } from "../journals-amendments-status-badge";
import "./journals-amendments-filters.scss";

interface JournalsAmendmentsFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  authorOptions: string[];
  authorFilter: string | null;
  onAuthorFilter: (value: string | null) => void;
  dateRange: [Dayjs | null, Dayjs | null];
  onDateRange: (value: [Dayjs | null, Dayjs | null]) => void;
  statusFilter: JournalsAmendmentsStatus[];
  onStatusFilter: (value: JournalsAmendmentsStatus[]) => void;
  sourceFilter: string | null;
  onSourceFilter: (value: string | null) => void;
  changeTypeFilter: string | null;
  onChangeTypeFilter: (value: string | null) => void;
}

export const JournalsAmendmentsFilters = ({
  search,
  onSearchChange,
  authorOptions,
  authorFilter,
  onAuthorFilter,
  dateRange,
  onDateRange,
  statusFilter,
  onStatusFilter,
  sourceFilter,
  onSourceFilter,
  changeTypeFilter,
  onChangeTypeFilter,
}: JournalsAmendmentsFiltersProps) => {
  const filtersPanel = (
    <div className="journals-amendments-filters__panel">
      <div className="journals-amendments-filters__field">
        <span>Проверил и подписал</span>
        <Select
          value={authorFilter}
          allowClear
          placeholder="Все"
          options={authorOptions.map((name) => ({
            value: name,
            label: name,
          }))}
          onChange={(value) => onAuthorFilter(value ?? null)}
        />
      </div>
      <div className="journals-amendments-filters__field">
        <span>Тип изменений</span>
        <Select
          value={changeTypeFilter}
          allowClear
          placeholder="Все"
          options={[
            { value: "Реквизиты", label: "Реквизиты" },
            { value: "Реквизиты СРО", label: "Реквизиты СРО" },
            { value: "Номер НОСТРОЙ", label: "Номер НОСТРОЙ" },
            { value: "Иные изменения", label: "Иные изменения" },
          ]}
          onChange={(value) => onChangeTypeFilter(value ?? null)}
        />
      </div>
      <div className="journals-amendments-filters__field">
        <span>Источник</span>
        <Select
          value={sourceFilter}
          allowClear
          placeholder="Все"
          options={[
            { value: "SYSTEM", label: "Системная заявка" },
            { value: "MANUAL", label: "Создана вручную" },
          ]}
          onChange={(value) => onSourceFilter(value ?? null)}
        />
      </div>
      <div className="journals-amendments-filters__field">
        <span>Дата создания</span>
        <DatePicker.RangePicker
          value={dateRange}
          onChange={(range) =>
            onDateRange(range ? [range[0], range[1]] : [null, null])
          }
          format="DD.MM.YYYY"
          allowEmpty={[true, true]}
        />
      </div>
      <div className="journals-amendments-filters__field">
        <span>Статус</span>
      <Checkbox.Group
        value={statusFilter}
        onChange={(v) => onStatusFilter(v as JournalsAmendmentsStatus[])}
      >
        <Space direction="vertical">
          <Checkbox value="NEW">Новое</Checkbox>
          <Checkbox value="SIGNING_CHANGES">Подписание изменений</Checkbox>
          <Checkbox value="PREPARING_XML">Подготовка XML</Checkbox>
          <Checkbox value="ON_SIGNING">На подписании</Checkbox>
          <Checkbox value="REJECTED">Отклонено</Checkbox>
          <Checkbox value="PUBLISHED">Опубликовано</Checkbox>
        </Space>
      </Checkbox.Group>
      </div>
    </div>
  );

  return (
    <div className="journals-amendments-filters">
      <div className="journals-amendments-filters__search-group">
        <InputSearch
          className="journals-amendments-filters__search"
          placeholder="Поиск"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          allowClear
        />
        <Tooltip title="Поиск по типу, причине, подписанту и статусу">
          <InfoCircleOutlined className="journals-amendments-filters__info" />
        </Tooltip>
      </div>
      <Popover content={filtersPanel} trigger="click" placement="bottomRight">
        <Button className="journals-amendments-filters__button">
          Фильтры
          <EqualizerIcon />
        </Button>
      </Popover>
    </div>
  );
};
